var getPromoterOfferPageLinks = function getPromoterOfferPageLinks(_ref) {
  var asPath = _ref.asPath,
    basePath = _ref.basePath,
    promoterId = _ref.promoterId,
    sellerId = _ref.sellerId;
  var promoterOfferPageRoute = "".concat(asPath == null ? void 0 : asPath.split(basePath).join('').replace('/p/', '/divulgador/oferta/'));
  var mobileLink = "https://m.magazineluiza.com.br".concat(promoterOfferPageRoute, "?promoter_id=").concat(promoterId, "&partner_id=3440&seller_id=").concat(sellerId);
  var desktopLink = "https://magazineluiza.com.br".concat(promoterOfferPageRoute, "?promoter_id=").concat(promoterId, "&partner_id=3440&seller_id=").concat(sellerId);
  return {
    desktop: desktopLink,
    mobile: mobileLink
  };
};
export default getPromoterOfferPageLinks;